"use strict";
/**
 * Created by Ning Jiang on 9/4/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreespinIntroController = void 0;
const ScreenController_1 = require("../../../core/screen/ScreenController");
const ParsedInitData_1 = require("../../../core/server/data/ParsedInitData");
const SlotGame_1 = require("../../../core/SlotGame");
// If restore in Freespin (Not on the first freespin), the FreespinIntro will do the restore work but not show.
// When restore on the first freespin (the round winning Freespin), show the Intro.
class FreespinIntroController extends ScreenController_1.ScreenController {
    constructor(config, tweakEnabled) {
        super("FreespinIntro", config, tweakEnabled);
        this._isRestoreFreespin = false;
        this._isFreespinWon = false;
    }
    calculateIsTriggered(data) {
        const isRestoreState = (data instanceof ParsedInitData_1.ParsedInitData) ? data.isRestoreState : false;
        this._isRestoreFreespin = isRestoreState && data.freespinsLeft > 0;
        this._isFreespinWon = data.freespinTriggeredThisSpin;
        this._remainingFreeSpins = data.freespinsLeft;
        return this._isFreespinWon || this._isRestoreFreespin;
    }
    show() {
        super.show();
        SlotGame_1.SlotGame.keypad.setZeroBetSpinCounter(this._remainingFreeSpins);
        return this._isFreespinWon;
    }
    shouldShow() {
        return this._isFreespinWon;
    }
}
exports.FreespinIntroController = FreespinIntroController;
//# sourceMappingURL=FreespinIntroController.js.map